export const customAdapter = ({ ...data }) => data
